import { createContext, useContext, useState } from 'react';
import { FullscreenModal } from './FullscreenModal';
import noop from 'lodash/noop';

const FullscreenContext = createContext({
  provided: false,
  fullscreen: false,
  fullscreenOpen: false,
  setFullscreenOpen: noop,
});

export const FullscreenProvider = ({ children }) => {
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  return (
    <FullscreenContext.Provider
      value={{ provided: true, fullscreen: false, fullscreenOpen, setFullscreenOpen }}
    >
      {children}

      {fullscreenOpen && (
        <FullscreenContext.Provider
          value={{ provided: true, fullscreen: true, fullscreenOpen, setFullscreenOpen }}
        >
          <FullscreenModal>{children}</FullscreenModal>
        </FullscreenContext.Provider>
      )}
    </FullscreenContext.Provider>
  );
};

export const useFullscreenContext = () => {
  return useContext(FullscreenContext);
};

export const withFullscreen = WrappedComponent => {
  return function WithFullscreenProvider(props) {
    return (
      <FullscreenProvider>
        <WrappedComponent {...props} />
      </FullscreenProvider>
    );
  };
};

export default FullscreenProvider;
